<script setup lang="ts">
const props = defineProps({ item: String, level: Number });
</script>

<template>
	<template v-if="level > 0">
		<i :class="`fa-duotone ${item} fa-lg`" style="margin-left: -2px"></i>
	</template>
	<template v-else>
		<i :class="`fa-duotone ${item} fa-lg`" style="margin-left: -2px"></i>
	</template>
</template>
